import axios from "axios";
import { Button } from "evergreen-ui";
import React from "react";
import { FaNewspaper } from "react-icons/fa";
import { admission } from "../ADMISSION";
function NewsDetail({ TYPE, MAJOR, ROB }) {
  const GetNews = async (type, major, rob) => {
    try {
      if (major === "9903") {
        type = "0";
      }
      const fetch = await axios.post(admission + "/student/getNews", {
        type: type,
        major: major,
        rob_id: rob,
      });
      const resp = fetch.data;
      console.log(resp);
      if (resp === null) {
        return 0;
      } else {
        let t = "0";
        if (type === "1" || type === "5") {
          t = "1";
        } else if (type === "2" || type === "3") {
          t = "2";
        } else if (type === "4" || type === "7") {
          t = "3";
        } else if (type === "6") {
          t = "5";
        } else if (type === "0") {
          t = "0";
        }
        // return "https://admission.kpru.ac.th/admission2017/" + resp;
        return "https://admission.kpru.ac.th/admission/News/" + t;
      }
    } catch (error) { }
  };
  return (
    <div  >
      <Button
        onClick={() => {
          // window.open()
          GetNews(TYPE, MAJOR, ROB).then((res) => {
            if (res === 0) {
            } else {
              window.open(res);
            }
          });
        }}
        iconBefore={<FaNewspaper />}
        minWidth={133}
        marginTop={8}
        appearance="primary"
      >
        ดูประกาศ
      </Button>
    </div>
  );
}

export default NewsDetail;
